import {Translation} from '@/i18n/locales/type.ts';

const en: Translation = {
  home: {
    firstVisit: "It's my first visit without a reservation",
    returningVisitor: 'Please enter either your phone number or email.',
    error_message: {
      invalid_token: 'Network connection is unstable.',
      search: 'An error occurred during the search.',
      checkin:
        'An error occurred during check-in. If the problem persists, please contact the front desk.',
    },
    dialog_message: {
      reservation: {
        checked_in:
          'Your reservation has been confirmed. Check-in is complete.',
        no_customer:
          'Customer information could not be found.\nPlease check the phone number or email again.',
      },
      walkin: {
        checked_in:
          'Check-in is complete. Please wait a moment and we will assist you in order.',
        no_customer_title: 'We could not find your information.',
        no_customer_description: 'Is this your first visit?',
        start_first_visit: 'Start First Visit Check-in',
        no_booking_title:
          'Hi {{name}}, we can help you with a same-day check-in.',
        no_booking_description:
          'We can help you with a same-day check-in.\nDepending on today’s schedule, there may be a wait or some treatments may be unavailable.',
        start_checkin: 'Check In',
      },
      no_booking: {
        title: 'No reservation found',
        description:
          'We operate on a reservation-only basis to ensure thorough care and sufficient consultation time.\nIf you have made a reservation, please inquire at the front desk.',
      },
      invalid_building: {
        title:
          'The hospital information is incorrect. If the hospital you are trying to check in at is not "Seoul Gangnam Muse Clinic Main Building, 2nd Floor", please ask the front desk for the correct check-in site address.',
      },
      common: {
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      confirm: {
        title: 'Welcome, {{name}}!',
        description: 'Would you like to proceed with your check-in now?',
        confirm: 'Yes, I’d like to',
        cancel: 'No',
      },
    },
    form: {
      title: {
        name: 'Reservation Name',
        phone: 'Phone Number',
        email: 'Email',
      },
      placeholder: {
        name: 'Enter your name',
        phone: 'Enter your phone number',
        email: 'Enter your email',
      },
      description: 'Please enter at least one of the phone number or email.',
      button: {
        title: 'Check In',
        loading: 'Searching...',
      },
      birth: {
        title: 'Please enter your date of birth to verify your information.',
        year: 'Year',
        month: 'Month',
        day: 'Day',
      },
    },
    customer_info: {
      title: 'Customer Information',
      name: 'Name',
      phone: 'Phone Number',
      email: 'Email',
      button_title: 'Proceed with Check-in',
    },
    language_select: {
      button_title: '🌐 Change Language',
    },
  },
  common: {
    or: 'or',
  },
  createChart: {
    title: 'New Chart Registration',
    error_message: {
      invalid_form: 'Please enter all information.',
      checkin: 'An error occurred during check-in process.',
    },
    dialog_message: {
      complete: {
        title:
          'Chart creation and check-in completed.\nWalk-in customers may experience a wait time. Thank you for your patience.',
        button_title: 'Confirm',
      },
    },
    form: {
      name: {
        title: 'Reservation Name',
        placeholder: 'Please enter your name.',
        passport_notice:
          'For accurate booking and smooth service, customers who do not hold Korean nationality are kindly requested to enter their name as it appears on their passport.',
      },
      phone: {
        title: 'Phone Number',
        placeholder: 'Please enter your phone number.',
      },
      email: {
        title: 'Email',
        placeholder: 'Please enter your email.',
      },
      birth: {
        title: 'Date of Birth',
        year: 'Year',
        month: 'Month',
        day: 'Day',
      },
      gender: {
        title: 'Gender',
        male: 'Male',
        female: 'Female',
      },
      button: {
        title: 'Create Chart & Check-in',
        loading: 'Creating chart...',
      },
    },
  },
};

export default en;
